<template>
	<div class="gradient-picker">
		<btn s="xs" @press="openModal">
			<span :style="{background:computedGradient}" class="color-template"></span>
		</btn>
		<pin-modal  ref="modal" label='Градиент'>
			<drag-input 
				label="Angle"
				:value='gradient.angle' 
				icon="repeat" 
				@input="(v)=>{setAngle(v)}"
			/>
			<div class="slider" :style="{width:sliderWidth+'px', background:computedGradient}">
				<mousemover 
					:ref="'point-'+index" 
					class="point" 
					:key="index"
					handler
					@move="(e)=>{onDrag(index, e)}"
					@mousedown="startPosition = gradient.points[index].position"
					v-for="(point, index) in gradient.points" 
					:style="{left:(sliderWidth*(point.position/100)+(index===0?0:0))+'px', top:'auto',background:point.color}"
				/>
			</div>

			<table style="width:100%;font-size:12px;border-collapse:collapse;border-color:lightgrey" border="1" class="text-center">
				<thead>
					<tr>
						<td>№</td>
						<td>Цвет</td>
						<td>Позиция</td>
						<td>Удалить</td>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(point, index) in gradient.points">
						<td>{{index+1}}</td>
						<td><color-picker :color="point.color" @input="(color)=>{updateValue(index, color)}"/></td>
						<td>{{point.position}}%</td>
						<td><btn icon="trash-alt" t='d' s="s" @press="remove(index)"/></td>
					</tr>
					<tr>
						<td colspan='4' class="text-center">
							<btn icon="plus" s="s" label="Добавить точку" @press="addPoint"/>
						</td>
					</tr>
				</tbody>
			</table>
		</pin-modal>
	</div>
</template>
<script>
	var defaultProps = {
	  hex: '#194d33',
	  hsl: {
	    h: 150,
	    s: 0.5,
	    l: 0.2,
	    a: 1
	  },
	  hsv: {
	    h: 150,
	    s: 0.66,
	    v: 0.30,
	    a: 1
	  },
	  rgba: {
	    r: 25,
	    g: 77,
	    b: 51,
	    a: 1
	  },
	  a: 1
	};
	import { Sketch } from 'vue-color';
	import ColorPicker from "./color-picker.vue";
	import PinModal from "./pin-modal.vue";
	export default {
		name:"gradient-picker",
		props:{
			gradient:{
				type:Object,
				default(){
					return {
			            "angle": 135,
			            "computed": "linear-gradient(135deg,#0089FF 0%,#004980 100%)",
			            "points": [
			              {
			                "color": "#0089FF",
			                "position": 0
			              },
			              {
			                "color": "#004980",
			                "position": 100
			              }
			            ]
					}
				}
			}
		},
		components:{PinModal,'sketch-picker':Sketch, ColorPicker},
		methods:{
			openModal(e){
				this.$refs.modal.onOpen(e);
			},
			move({dx}){
				console.log(dx)
			},
			setAngle(angle){
				let {gradient,computedGradient} = this;
				gradient.angle = angle;
				this.$emit('input', {points:gradient.points,angle:gradient.angle,computed:computedGradient});
			},
			updateValue(index, color){
				let {gradient} = this;
				gradient.points[index].color = color;
				this.$emit('input', {points:gradient.points,angle:gradient.angle,computed:this.computedGradient});
			},
			onDrag(index, {dx}){
				let {gradient} = this;
				let newPosition = Math.max(Math.min(100, this.startPosition+(100*dx/this.sliderWidth)), 0);
				gradient.points[index].position = newPosition;
				this.$emit('input', {points:gradient.points.sort((a,b)=>{return a.position>b.position}),angle:gradient.angle,computed:this.computedGradient});
			},
			addPoint(){
				let {gradient} = this;
				gradient.points.push({color:'red', position:100});
				this.$emit('input', {points:gradient.points,angle:gradient.angle,computed:this.computedGradient});
			},
			remove(index){
				let {gradient} = this;
				gradient.points.splice(index,1);
				this.$emit('input', {points:gradient.points,angle:gradient.angle,computed:this.computedGradient});
			}/*,
			onDragStop(){
				document.removeEventListener('mousemove',this.onDrag);
				document.removeEventListener('mouseup',this.onDragStop);
			}*/
		},
		computed:{
			computedGradient(){
				let computed = [];
				this.gradient.points.map(point=>{
					computed.push(`${point.color} ${point.position}%`);
				})
				return `linear-gradient(${this.gradient.angle}deg,${computed.join(',')})`
			}
		},
		data(){
			return {
				isOpen:!false,
				sliderWidth:200,
				startPosition:0,
				x:0,
				y:0
			}
		}
	}
</script>
<style scoped>
	.slider{
		background: black;
		overflow:hidden;
		height:20px;
	}
	.point{
		height:24px;
		width:12px;
		background: green;
		position: absolute;
		border:3px solid white;
		border-radius: 3px;
		margin-top:-3px;
		box-shadow: 0px 0px 1px grey;
	}
	.gradient-picker{
		display: inline-block;
		vertical-align: middle;
	}
	.color-template{
		width:24px;
		height:14px;
		margin:2px;
		display: inline-block;
	}
</style>